export const ValidationErrors = {
  required: (fieldName: string) => `${fieldName} is required.`,
};
